export default {
  appName: "BlockSignal",

  /////////////////////////개발/////////////////////////////
  // serverProtocol: "http",
  // serverIp: "localhost",
  // serverPort: "18001",

  /////////////////////////운영 /////////////////////////////
  // serverProtocol: "https",
  // serverIp: "podomall.back.blocksignal.co.kr",
  // serverPort: "443",

  /////////////////////////운영 /////////////////////////////
  // serverProtocol: "https",
  // serverIp: "bigworld.back.blocksignal.co.kr",
  // serverPort: "443",

  /////////////////////////운영 /////////////////////////////
  // serverProtocol: "https",
  // serverIp: "dabaq.back.blocksignal.co.kr",
  // serverPort: "443",

  /////////////////////////운영 /////////////////////////////
  // serverProtocol: "https",
  // serverIp: "rclub.back.blocksignal.co.kr",
  // serverPort: "443",

  /////////////////////////운영 /////////////////////////////
  // serverProtocol: "https",
  // serverIp: "upcard.back.blocksignal.co.kr",
  // serverPort: "443",

  /////////////////////////운영 /////////////////////////////
  serverProtocol: "https",
  serverIp: "sevora.back.blocksignal.co.kr",
  serverPort: "443",

  clientId: "",
  clientSecret: "",
  serverContext: "",
};
